import {
  ACTION_CHANGE_UPDATES_SUBSCRIBE,
  CATEGORY_CHECKOUT,
} from 'utils/analytics/eventTypesConstants';
import { Checkbox } from 'omakase';
import { CommunicationOptInSettings } from './AcceptTermsForm';
import { core } from '@tock/coretypes';
import { useHasDirectBrandUpdateFlags } from 'hooks/useHasDirectBrandUpdateFlags';

interface Props {
  isTableSideOrder: boolean;
  selectedExperience?: core.ITicketType;
  businessName?: string;
  consentsToSMS: ReduxFormField<boolean>;
  hasVerifiedAge: ReduxFormField<boolean>;
  optsInToEmail: ReduxFormField<boolean>;
  requiredAge?: number;
  communicationsOptInSettings: CommunicationOptInSettings;
}

const AcceptTermsCheckboxes: React.FunctionComponent<Props> = ({
  isTableSideOrder,
  selectedExperience,
  businessName,
  consentsToSMS,
  hasVerifiedAge,
  requiredAge,
  optsInToEmail,
  communicationsOptInSettings,
}) => {
  const hasTwilioDirectBrandUpdatesFlag = useHasDirectBrandUpdateFlags();
  const showSmsConsent = () => {
    return !isTableSideOrder && !hasTwilioDirectBrandUpdatesFlag;
  };

  const checkboxes = [];

  if (showSmsConsent()) {
    const experienceType = ['ORDER_DELIVERY', 'ORDER_PICKUP'].includes(
      selectedExperience?.variety || ''
    )
      ? 'order'
      : 'reservation';
    const label = `I agree to receive text messages from ${
      businessName || 'the business'
    } related to this ${experienceType}`;
    checkboxes.push(
      <Checkbox
        data-testid="checkout-consents-to-text"
        name="consentsToSMS"
        id="consentsToSMS"
        checked={consentsToSMS.value}
        onChange={consentsToSMS.onChange}
        value={consentsToSMS.value}
        label={<span>{label}</span>}
        key="consentsToSMS"
        weight="book"
      />
    );
  }

  if (requiredAge) {
    checkboxes.push(
      <Checkbox
        data-testid="age-agree"
        name="hasVerifiedAge"
        id="hasVerifiedAge"
        checked={hasVerifiedAge.value}
        onChange={hasVerifiedAge.onChange}
        value={hasVerifiedAge.value}
        label={`I agree that a recipient over the age of ${requiredAge} with a valid government ID will be present to accept the order`}
        key="hasVerifiedAge"
        weight="book"
        error={!!hasVerifiedAge.error}
        errorText={hasVerifiedAge.error}
      />
    );
  }

  const { showControl, optInText } = communicationsOptInSettings;
  if (showControl) {
    checkboxes.push(
      <Checkbox
        data-testid="checkout-opt-in-email"
        name="optsInToEmail"
        id="optsInToEmail"
        checked={optsInToEmail.value}
        onChange={(change) => {
          window.analytics?.sendEvent(
            CATEGORY_CHECKOUT,
            ACTION_CHANGE_UPDATES_SUBSCRIBE,
            change.target.checked
          );
          optsInToEmail.onChange(change);
        }}
        value={optsInToEmail.value}
        label={optInText}
        key="optsInToEmail"
        weight="book"
      />
    );
  }

  return checkboxes.length ? <div className="ConsumerCheckout-section">{checkboxes}</div> : null;
};

export default AcceptTermsCheckboxes;
